export const SEARCH_MODE_HOURLY = 'hourly'
export const SEARCH_MODE_PREPAID = 'prepaid'
export const SEARCH_MODE_MONTHLY = 'subscriptions'
export const SEARCH_MODE_EVENTS = 'events'

export const SEARCH_REQUEST_LOCATIONS_BY_NAME = 'SEARCH_REQUEST_LOCATIONS_BY_NAME'
export const SEARCH_LOCATIONS_RECEIVED = 'SEARCH_LOCATIONS_RECEIVED'
export const GOOGLE_SEARCH_LOCATIONS_RECEIVED = 'GOOGLE_SEARCH_LOCATIONS_RECEIVED'

export const SEARCH_REQUEST_EVENTS = 'SEARCH_REQUEST_EVENTS'
export const SEARCH_EVENTS_RECEIVED = 'SEARCH_EVENTS_RECEIVED'
export const CLEAR_SEARCH_EVENTS = 'CLEAR_SEARCH_EVENTS'
export const SET_SEARCH_EVENT_INPUT_VALUE = 'SET_SEARCH_EVENT_INPUT_VALUE'
export const REMOVE_SEARCH_EVENT_INPUT_VALUE = 'REMOVE_SEARCH_EVENT_INPUT_VALUE'
export const SET_EVENT = 'SET_EVENT'
export const ADD_EVENT_DETAILS = 'ADD_EVENT_DETAILS'
export const REMOVE_EVENT = 'REMOVE_EVENT'

export const STOP_SEARCH_REQUEST = 'STOP_SEARCH_REQUEST'
export const CLEAR_SEARCH_LOCATIONS = 'CLEAR_SEARCH_LOCATIONS'
export const CLEAR_GOOGLE_SEARCH_LOCATIONS = 'CLEAR_GOOGLE_SEARCH_LOCATIONS'

export const SELECT_SEARCH_LOCATION = 'SELECT_SEARCH_LOCATION'
export const REMOVE_SEARCH_LOCATION = 'REMOVE_SEARCH_LOCATION'

export const SUGGESTION_TYPE_PARKING_LOT = 'SUGGESTION_TYPE_PARKING_LOT'
export const SUGGESTION_TYPE_GOOGLE_LOCATION = 'SUGGESTION_TYPE_GOOGLE_LOCATION'

export const SET_SEARCH_DATETIME = 'SET_SEARCH_DATETIME'
export const competitors = [
    'Q-Park',
    'Canada Wide Parking',
    `Park'N Fly`,
    'Advanced Parking',
    'CF Parking',
    'Diamond Parking Services',
    'DPS',
    'EasyPark',
    'Edmonton Parking',
    'EPark',
    'GoPark',
    'HonkMobile',
    'Impark',
    'Imperial Parking',
    'Metro Parking',
    'Parking Panda',
    'Paybyphone',
    'Precise',
    'Precise Parklink',
    'Robbins Parking',
    'Royal Parking',
    'Target Parking',
    'UBC Parking',
]

export const BOOKABLE_SEASON_TICKET_ONLY = 'season-ticket-only'
export const BOOKABLE_RESERVATION_ONLY = 'reservation-only'
